import React, { FC } from "react";
import { Button, ButtonProps } from "@mui/material";
import { buttonStyles } from "./styles";

export interface ButtonOutlinedProps extends ButtonProps {
  children: React.ReactNode;
}

export const ButtonOutlined = ({
  children,
  onClick,
  variant = "outlined",
  disabled,
  ...props
}: ButtonOutlinedProps) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      sx={buttonStyles}
      {...props}
    >
      {children}
    </Button>
  );
};
